<template>
    <div id="patent-search">
        <PatentSearch :key="componentKey" />
    </div>
</template>

<script setup>
import { watch, ref } from 'vue'
import { useRoute } from 'vue-router'
import PatentSearch from '@/components/patentSearch/PatentSearch.vue'

const route = useRoute()
const componentKey = ref(0)

watch(
    () => route.fullPath,
    (newPath, oldPath) => {
        const oldHasSeed = oldPath.includes('seedString')
        const newHasSeed = newPath.includes('seedString')

        if (oldHasSeed !== newHasSeed || (oldHasSeed && newHasSeed && newPath !== oldPath)) {
            componentKey.value++
        }
    }
)
</script>

<style scoped lang="scss">
#patent-search {
    height: calc(100vh - 64px); // minus header
}
</style>
